export const normalizeDigits = (value) => value
  .replace(/[۰-۹]/g, (digit) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(digit)))
  .replace(/[٠-٩]/g, (digit) => String("٠١٢٣٤٥٦٧٨٩".indexOf(digit)));

export const normalizeMobileNumber = (value) => {
  const digits = normalizeDigits(value).replace(/\D/g, "");

  if (digits.startsWith("0098")) {
    return `0${digits.slice(4)}`.slice(0, 11);
  }

  if (digits.startsWith("98")) {
    return `0${digits.slice(2)}`.slice(0, 11);
  }

  return digits.slice(0, 11);
};

export const formatMobileNumber = (value) => {
  const digits = normalizeMobileNumber(value);
  const parts = [
    digits.slice(0, 4),
    digits.slice(4, 7),
    digits.slice(7, 11),
  ].filter(Boolean);

  return parts.join(" ");
};
